import React, { Component } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router';
import Login from './Login';
import HomeCertificate from './HomeCertificate';
import VerifyUser from './VerifyOtp';
import DownloadReport from './DownloadReport';
import Information from './Information';
import Communication from './Communication';

class App extends Component {

  render() {
    return (

      <Router>
        <Routes>
          <Route path="/" element={<Login />} render={(props) => <Login {...props} ref={this.state} />} key="login"/>
          <Route path="/verifyUser" element={<VerifyUser />}  render={(props) => <VerifyUser {...props} refreshRout={"/verifyUser"} ref={this.state} />}  key="verifyUser"/>
          <Route path="/certificate" element={<HomeCertificate />} render={(props) => <HomeCertificate {...props} ref={this.state} />}  key="homeCertificate"/>
          <Route path="/downloadReport" element={<DownloadReport />} render={(props) => <DownloadReport {...props} ref={this.state}  key="downLoad"/>} />
          <Route path="/information" element={<Information />} render={(props) => <Information {...props} ref={this.state} key="information"/>} />
          <Route path="/communication" element={<Communication />} render={(props) => <Communication {...props} ref={this.state} key="communication"/>} />
        </Routes>
      </Router>
    );
  }
}

export default App;
